import MainContent from "../components/MainContent";
import Layout from "../components/Layout";

const ArtistsPage = () => (
  <Layout>
    <MainContent contentType="artists" />
  </Layout>
);

export default ArtistsPage;
